import React from 'react';
import withInit from 'WithInit';
import PropTypes from 'prop-types';
import { PaginationManager } from 'SelfServeBuilder';
import SelfServeBuilderSidePanelWithRedux, { SelfServeBuilderSidePanelTypes } from 'SelfServeBuilderSidePanel';
import SelfServeTooltipTourConstants from 'SelfServeTooltipTour/TooltipTourConstants';
import TextBoxToolItem from './TextBoxToolItem';
import MultipleChoiceToolItem from './MultipleChoiceToolItem';
import CheckboxToolItem from './CheckboxToolItem';
import SignatureToolItem from './SignatureToolItem';
import TooltipToolItem from './TooltipToolItem';

const TOOLBOX_OPEN_PANEL_WIDTH = 160;
// manages organizing sections and adding recipients
class SelfServeBuilderToolbox extends React.PureComponent {
  constructor(props) {
    super(props);

    this.texboxToolboxRef = React.createRef();
    this.multipleChoiceToolboxRef = React.createRef();
    this.checkboxToolboxRef = React.createRef();
    this.signatureToolboxRef = React.createRef();
    this.tooltipButtonRef = React.createRef();
  }

  componentDidMount() {
    if (!this.props.isZeroState) {
      window._track('Textbox | Toolbar', 'Template Builder');
    }
  }

  render() {
    return (
      <SelfServeBuilderSidePanelWithRedux
        leftPlacement
        panelType={SelfServeBuilderSidePanelTypes.TOOLBOX}
        collapsible={false}
        openWidth={TOOLBOX_OPEN_PANEL_WIDTH}
      >
        <div className="self-serve-builder-toolbox-container">
          <TextBoxToolItem
            toolboxRef={this.texboxToolboxRef}
            tooltipName={SelfServeTooltipTourConstants.TOOLBOX_TEXTBOX_TOOLTIP}
          />
          <MultipleChoiceToolItem
            toolboxRef={this.multipleChoiceToolboxRef}
            tooltipName={SelfServeTooltipTourConstants.TOOLBOX_MULT_CHOICE_TOOLTIP}
          />
          <CheckboxToolItem
            toolboxRef={this.checkboxToolboxRef}
            tooltipName={SelfServeTooltipTourConstants.TOOLBOX_CHECKBOX_TOOLTIP}
          />
          <SignatureToolItem
            toolboxRef={this.signatureToolboxRef}
            tooltipName={SelfServeTooltipTourConstants.TOOLBOX_SIGNATURE_TOOLTIP}
          />
          <TooltipToolItem
            toolboxRef={this.tooltipButtonRef}
            tooltipName={SelfServeTooltipTourConstants.TOOLBOX_TIPS_LIST_TOOLTIP}
            tooltipNameAlt={SelfServeTooltipTourConstants.TOOLBOX_TIPS_TOOLTIP}
          />
          <PaginationManager />
        </div>
      </SelfServeBuilderSidePanelWithRedux>
    );
  }
}

SelfServeBuilderToolbox.defaultProps = {
  isZeroState: false,
};

SelfServeBuilderToolbox.propTypes = {
  isZeroState: PropTypes.bool,
};


export default withInit(SelfServeBuilderToolbox, true);



// WEBPACK FOOTER //
// ./src-react/SelfServeBuilderToolbox/index.jsx